// Shadows generator
export const shadowKeyUmbraOpacity = 0.14
const shadowKeyPenumbraOpacity = 0.1
const shadowAmbientShadowOpacity = 0.08

export function createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0, 0, 0, ${shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0, 0, 0, ${shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0, 0, 0, ${shadowAmbientShadowOpacity})`,
    ].join(",")
}

export const toPlainObject = (something: any): any => JSON.parse(JSON.stringify(something))
